import { styled, keyframes, css } from 'styled-components';
import { Button } from '@/shared/ui/form/button';

// export const WrapperForm = styled.div`
//   margin-top: 20px;

//   input::placeholder {
//     color: #afafaf;
//     opacity: 0.4;
//   }
// `;

export const FormGroup = styled.form`
  margin-top: 74px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  input::placeholder {
    color: #afafaf;
    opacity: 0.4;
  }
`;

export const MaxAmountButton = styled.div`
  border-radius: 20px;
  background: linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%), #27262b;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset;
  backdrop-filter: blur(27.75px);
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    // margin-bottom: 8px;
  }
`;

export const WithdrawButton = styled(Button)`
  width: 100%;
`;

export const AdressesWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// Анимация мигания
const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
`;

export const AddressBlock = styled.div<{
  $border?: boolean;
  $blinking?: boolean;
}>`
  border: ${(props) => (props.$border ? '1px solid #FF7001' : 'none')};
  border-radius: 8px;
  background: rgba(39, 38, 43, 0.6);
  padding: 12px;
  text-align: left;
  cursor: pointer;

  ${({ $blinking }) =>
    $blinking &&
    css`
      animation: ${blink} 1s ease-in-out infinite;
    `}

  svg {
    cursor: pointer;
  }
`;
